var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_4687_55471)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1553 11.8843V13.6778C13.1553 13.7272 13.1152 13.7672 13.0658 13.7672H6.23831C6.15569 13.7672 6.11725 13.6648 6.17947 13.6104L10.0842 10.1989C10.289 10.02 10.2881 9.70127 10.0822 9.52359L6.18206 6.15715C6.11932 6.10299 6.15762 6 6.2405 6H13.0658C13.1152 6 13.1553 6.04004 13.1553 6.08944V7.41223",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4687_55471",
    x1: 0,
    y1: 0,
    x2: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEractive);
export default __webpack_public_path__ + "static/media/er.active.3ffd20bd890299d384107df11317ef7d.svg";
export { ForwardRef as ReactComponent };